import React, {useState, useEffect}  from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate,useParams,Link,useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ShipmentTracking(){
    let navigate = useNavigate();
    const { slip_no } =useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get("type"); // "LR" ya "AWB"
    const [status, setStatus] = useState([]);
    const [button, setButton] = useState([]);
    const [ShipmentDetails, setShipmentDetails] = useState([]);
    const{headers1,headers2,logout}=AuthUser();
    const [ActiveAWB, setActiveAWB] = useState('');

    useEffect(()=>{
        GetTrackingDetails();
    },[]);

    const GetTrackingDetails=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Getshipmentdetailsbyslipno',
            headers:headers1,
            data: {
                slip_no: slip_no,
                type: type
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var statusdetails = response.data.value
                var statusdata = response.data.value.shipmentallstatus;
                var shipdata = response.data.awb;
               
                setStatus(statusdata); //All status details 
                setButton(shipdata); //Lr Button 
                setShipmentDetails(statusdetails);
                setActiveAWB(statusdata); //Button Active 
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }

    const GetSlipNo=(slipno)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Getshipmentdetailsbyslipno',
            headers:headers1,
            data: {
                slip_no: slipno,
                type: 'AWB'
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var statusdata = response.data.value.shipmentallstatus;
                setStatus(statusdata); //All status details 
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }

    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Shipments Tracking</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">{type === "AWB" ? "AWB" : "LR"} #{slip_no} </h2>
                        </div>
                    </div>
                </div>
            </div>
                {type === "AWB" && (
                    <div className="col-md-12">
                        <div className="row shipment_detail_sho">
                        <div className="col-md-3"></div>
                            <div className="col-12 col-md-6">
                                
                                <div className="card mb-3 sticky-top">
                                    <div className="card-body">
                                    {status !=undefined && status !='' ?
                                    <>
                                        <div className="row mb-3">
                                            <div className="col-12 col-md-2">
                                                <div className="icon_sm">
                                                    <i className="bx bx-search"></i>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md">
                                                <h3>Shipment Tracking</h3>
                                            </div>
                                        </div>
                                        
                                        <div className="timeline-wrapper"> 
                                            <ul className="StepProgress">
                                                {status.map((st,i)=>{
                                                    return(
                                                <li className="StepProgress-item is-done" key={i}>
                                                    <div className="bold time">
                                                        <h4>{st.pickup_time}</h4>
                                                        <h6>{st.pickup_time}</h6>
                                                        <h5>{st.city}</h5>
                                                    </div> 
                                                    <div className="bold">{st.Details}
                                                        <p>{st.Activites}</p>
                                                        <small>Updated By: {st.name}     </small>
                                                    </div>
                                                </li>
                                                );
                                            })}
                                            </ul>
                                        </div>
                                        </>
                                        :
                                        <h6 className="text-danger text-center pt-2">Recode Not Found</h6>
                                        
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {type === "LR" && (
                    <div className="col-md-12">
                        <div className="row shipment_detail_sho">
                            <div className="col-md-3">
                                <div className="btn-toolbar mb-3" role="toolbar" aria-label="Toolbar with button groups">
                                    {button.map((aw,index) => 
                                        <div className="btn-group-vertical me-2" role="group" aria-label="First group">
                                            <button type="button" className={`btn mb-2 ${ ActiveAWB === aw.slip_no || (!ActiveAWB && index === 0) ? "btn-primary text-white" : "btn-outline-primary" }`} onClick= { () => {GetSlipNo(aw.slip_no); setActiveAWB(aw.slip_no);} } >{aw.slip_no} <span dangerouslySetInnerHTML={{__html:aw.status_name}}></span></button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                
                                <div className="card mb-3 sticky-top">
                                    <div className="card-body">
                                    {status !=undefined && status !='' ?
                                    <>
                                        <div className="row mb-3">
                                            <div className="col-12 col-md-2">
                                                <div className="icon_sm">
                                                    <i className="bx bx-search"></i>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md">
                                                <h3>Shipment Tracking</h3>
                                            </div>
                                        </div>
                                        
                                        <div className="timeline-wrapper"> 
                                            <ul className="StepProgress">
                                                {status.map((st,i)=>{
                                                    return(
                                                    <li className="StepProgress-item is-done" key={i}>
                                                        <div className="bold time">
                                                            <h4>{st.pickup_time}</h4>
                                                            <h6>{st.pickup_date}</h6>
                                                            <h5>{st.city}</h5>
                                                        </div> 
                                                        <div className="bold">{st.Details}
                                                            <p>{st.Activites}</p>
                                                            <small>Updated By: {st.name}     </small>
                                                        </div>
                                                    </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                        </>
                                        :
                                        <h6 className="text-danger text-center pt-2">LR Recode Not Found</h6>
                                        
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            <Footer/>
        </main>
        </>

    );
}
export default ShipmentTracking;